import { PDFPage } from "../../../../components/formflow/PDFPage";
import { FIELD_TYPES } from "../../../../constants/formflow/fieldTypes";
import { FieldOverlay } from "./FieldOverlay";

export function BuilderCenterPanel({ form, activeType, drag, selField, containerRef, handleCanvasClick, handleFieldDown, currentRole, pages }) {
  const hasPdf = !!form.file?.public_url;

  return (
    <div className="flex-1 overflow-auto p-7 cursor-crosshair bg-slate-100" style={{ cursor: activeType ? "crosshair" : "default" }} onClick={handleCanvasClick}>
      <div className="flex justify-center">
        <div ref={containerRef} className="bg-white shadow-lg relative w-full">
          {hasPdf ? (
            <div className="relative">
              <div>
                {pages?.map((src, pageIndex) => (
                  <div key={pageIndex} data-page={pageIndex} className="relative mb-5">
                    <img src={src} alt={`Page ${pageIndex + 1}`} className="w-full block" />
                    {form.fields
                      .filter((f) => f.pageIndex === pageIndex)
                      .map((field) => (
                        <FieldOverlay key={field.id} field={field} roles={form.roles} isSelected={selField === field.id} onMouseDown={handleFieldDown} activeType={activeType} />
                      ))}
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <PDFPage pdfName={form.pdfName} />
          )}

          {/* Placement hint */}
          {activeType && (
            <div className="absolute top-3 left-1/2 -translate-x-1/2 bg-slate-900 text-white px-4 py-2 rounded-full text-xs font-medium pointer-events-none whitespace-nowrap shadow-lg z-10">
              Click to place {FIELD_TYPES.find((f) => f.id === activeType)?.label} → <b>{currentRole?.name}</b>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
